export var VIEW_INFO = {};

VIEW_INFO[AMSAPI.APPLICANTS] = {
    title: $filter("translate")("New Applicants")
};

VIEW_INFO[AMSAPI.PROCEED] = {
    title: $filter("translate")("Phone interview")
};

VIEW_INFO[AMSAPI.INTERVIEW] = {
    title: $filter("translate")("First interview")
};

VIEW_INFO[AMSAPI.SECOND_INTERVIEW] = {
    title: $filter("translate")("Second interview")
};

VIEW_INFO[AMSAPI.HIRED] = {
    title: $filter("translate")("Hired")
};

VIEW_INFO[AMSAPI.PASSED] = {
    title: $filter("translate")("Skip")
};

VIEW_INFO[AMSAPI.OFFER] = {
    title: $filter("translate")("Offer")
};

VIEW_INFO[AMSAPI.ONBOARDING] = {
    title: $filter("translate")("Onboarding")
};

VIEW_INFO[AMSAPI.RIGHT_TO_WORK] = {
    title: $filter('translate')('Right To Work')
};

VIEW_INFO[AMSAPI.VIDEO_INTERVIEW] = {
    title: $filter('translate')('Video Screening')
};

VIEW_INFO[AMSAPI.BACKGROUND_CHECK] = {
    title: $filter('translate')('Background Check')
};

VIEW_INFO[AMSAPI.TRUST_ID] = {
    title: 'RTW ' + $filter('translate')('Check')
};

VIEW_INFO[AMSAPI.KEESING] = {
    title: $filter('translate')('Right To Work')
};

VIEW_INFO[AMSAPI.SCREENING_STAGE_2] = {
    title: $filter('translate')('Screening Stage 2')
};

VIEW_INFO[AMSAPI.SCREENING_STAGE_3] = {
    title: $filter('translate')('Screening Stage 3')
};

VIEW_INFO[AMSAPI.READY_TO_OFFER] = {
    title: $filter('translate')('Suitable to offer')
};
VIEW_INFO[AMSAPI.APPLICANTS_AUTO_IMPORT] = {
    title: $filter('translate')('Pre-hire')
};

VIEW_INFO[AMSAPI.OUTMATCH] = {
    title: $filter('translate')('Outmatch')
};

VIEW_INFO[AMSAPI.HARVER] = {
    title: $filter('translate')('Harver')
};

export const INTERVIEW_STAGES = {
    PHONE: VIEW_INFO[AMSAPI.PROCEED].title,
    INTERVIEW: VIEW_INFO[AMSAPI.INTERVIEW].title,
    SECOND_INTERVIEW: VIEW_INFO[AMSAPI.SECOND_INTERVIEW].title
};